import {
  LoaderFunctionArgs,
  Outlet,
  useLoaderData,
  useOutletContext,
} from "react-router";
import invariant from "tiny-invariant";

import { TSimulation } from "@/types";

export async function loader({ params }: LoaderFunctionArgs) {
  const { simulationId } = params;
  invariant(simulationId, "No simulation id found.");

  const response = await fetch(`/api/client/simulations/${simulationId}`);

  const { data: simulation } = (await response.json()) as { data: TSimulation };

  invariant("Cannot find simulation!");

  return { ok: true, simulation };
}

type ContextType = {
  simulation: TSimulation;
};

// See https://reactrouter.com/en/main/hooks/use-outlet-context
export function useSimulationContext() {
  return useOutletContext<ContextType>();
}

function Simulation() {
  const { simulation } = useLoaderData<typeof loader>();

  return <Outlet context={{ simulation } satisfies ContextType} />;
}

export default Simulation;
